<template>
  <div style="display: none"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/services/eventbus'

/**
 * The land owned and maintained by the Rijkswaterstaat 
 *  Mainly situated around highways
 */
export default {
  name: "RWSBeheer",
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      layerName: 'evmaps_nl_rws_beheergebied',
      type: 'fill',
      minzoom: 12,
      paint: {
        "fill-color": "hsla(339, 100%, 37%, 0.2)", // "hsl(52, 73%, 73%)",
        "fill-opacity": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12,
          0,
          13,
          0.90
        ]
      },
      layout: {}
    }
  },
  computed: {
    ...mapGetters('prognose', [
      'labelLayer'
    ]),
    ...mapGetters('access', [
      'getActiveMunicipality',
      'hasAdminAccess'
    ]),
    superuser() {
      return this.$auth.user && this.$auth.user['https://evmaps.nl/superuser']
    },
    hasAccess() {
      return this.superuser || this.hasAdminAccess({ code: this.getActiveMunicipality }) || ['0335', '1783'].includes(this.getActiveMunicipality)
    },
    source() {
      return {
        url: process.env.VUE_APP_RWSBEHEER_URL || `mapbox://journeyworks.${this.layerName}`,
        layer: process.env.VUE_APP_RWSBEHEER_SOURCE || this.layerName
      }
    }
  },
  watch: {
    loaded(loaded) {
      if (!loaded) return

      this.addLayer()
    }
  },
  created() {
    if (this.loaded) {
      this.addLayer()
    }
  },
  methods: {
    /**
     * Add the layer
     */
    addLayer() {
      // if (! this.hasAccess) return

      if (! this.source.url || ! this.source.layer) return

      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
      }
      if (this.$store.map.getSource(this.layerName)) {
        this.$store.map.removeSource(this.layerName)
      }
      
      this.$nextTick(() => {
        this.$store.map.addSource(this.layerName, {
          type: 'vector',
          url: this.source.url
        })

        this.$store.map.addLayer({ 
          "id": this.layerName,
          "type": this.type,
          "source": this.layerName,
          "source-layer": this.source.layer,
          "minzoom": this.minzoom,
          "paint": this.paint,
          "layout": this.layout
        }, this.labelLayer)
        
        EventBus.$emit('layers.national.loaded', {
          name: this.layerName
        })
      })
    }
  }
}
</script>
